@use '../../../scss/utility';

:host {
  /** @prop --z-index: z-index of the component */
  --z-index: #{utility.$wb-z-index-tooltip};

  display: inline-flex;
  position: relative;
}

:host([variant='inline']) {
  display: inline;
}
